import React from 'react'

import {
  PageLoadingWrapper,
} from '../../styles/loading'

const PageLoading = () => (
  <PageLoadingWrapper>
    <span role="img" aria-label="loading">💛</span>
  </PageLoadingWrapper>
)

export default PageLoading



// WEBPACK FOOTER //
// ./src/views/misc/PageLoading.js